import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  assetDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './bulk-change-asset-types-dialog.controller';
import template from './bulk-change-asset-types-dialog.html';
import bulkChangeAssetTypesConfirmDialog from '../dialog.bulkChangeAssetTypesConfirmDialog';


class dialogService {
  getOptions($event, { customerId, assetType, assetTypes }) {
    return {
      controller,
      controllerAs: 'bulkChangeAssetTypesDialogVM',
      locals: {
        customerId,
        assetType,
        assetTypes,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.admin.asset.bulkChangeAssetTypesDialog', [
  ngCookies,
  assetDataService,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkChangeAssetTypesConfirmDialog,
])
  .service('bulkChangeAssetTypesDialog', dialogService)
  .name;
